import React, { Component } from 'react';
import { buyNow } from '../../utils/api';
import ProductPageStickyCta from '../../scripts/ProductPage/ProductPageStickyCta.js';
import ReactHtmlParser from 'react-html-parser';
import Spinner from '../Spinner/Spinner';
import A11yHelpers from '../../scripts/A11yHelpers';

class ProductStickyCta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productData: {},
            api: {},
            status: '', // read only
            productId: '',
            domainId: '',
            isLoading: true,
            updatedOnce: false
        };
        /* Bindings */
        // this.getAllPageData = this.fetchProductSuiteDataApiCall.bind(this);
        this.handleBuyNowCourse = this._handleBuyNow.bind(this);
        this.handleProductCtaStickyness = this._handleProductCtaStickyness.bind(this);
        this.handleProductCtaOnResize = this._handleProductCtaOnResize.bind(this);
        this.handleOfs = this._handleOfs.bind(this);
        /* Variable declarations for external elements */
        // targeted element which constitutes the cta box in HTML.
        this.targetCtaBox = '';
        // the element that acts as the lower stopping element for stickyness.
        this.stopStickynessElement = '';
        // the parent for the cta box.
        this.ctaBoxParent = '';
        // the header for the page which is used for measuring placement.
        this.ctaHeaderBlock = '';
        // the banner which has some measuring uses.
        this.theCurrentBanner = '';
        // the collapsing portion of the banner which is used for measuring vertical placement.
        this.certsCollapsingBlock = '';
        // the imported Class that handles some DOM changes for this component.
        this.productCtaBoxClass = '';
        // the var used to assign all the elements that have the data-ofs attribute.
        this.ofsGroup = null;
    }

    async componentDidMount() {
        const productNum = window.productCourseId ? window.productCourseId : window.productSuiteId;
        if (this.props.ctaData && productNum) {
            const data = this.props.ctaData.data.data;
            const domainNum = (data && data.api && data.api.domain_id) ? data.api.domain_id : '';
            this.setState({ productData: data.data ? data.data : {} });
            this.setState({ api: data.api ? data.api : {} });
            this.setState({ productId: productNum });
            this.setState({ domainId: domainNum });
            this.setState({ isLoading: false });
        }

        this.targetCtaBox = document.querySelector('#productBox');
        this.stopStickynessElement = document.querySelector('.skye-footer');
        this.ctaBoxParent = document.querySelector('.product-box__container__block');
        this.ctaHeaderBlock = document.querySelector('.header-block');
        this.theCurrentBanner = document.querySelector('.page-banner__block__t2.prod-pg');
        this.certsCollapsingBlock = document.querySelector('.certs-collapse');

        /* Instantiate and apply stickyness */
        this.productCtaBoxClass = new ProductPageStickyCta(this.targetCtaBox, this.stopStickynessElement, 'product-box__cta__block mat-dropshadow active', 'product-box__cta__block mat-dropshadow inactive', this.ctaBoxParent, this.ctaHeaderBlock, this.theCurrentBanner, this.certsCollapsingBlock);
        let statusOnLoad = this.productCtaBoxClass.SetStickyness();
        this.setState({ status: statusOnLoad });
        document.addEventListener('scroll', this.handleProductCtaStickyness);
        document.addEventListener('resize', this.handleProductCtaOnResize);
    }

    async componentDidUpdate() {
        this.ofsGroup = document.querySelectorAll('.data-ofs');
        if (this.ofsGroup && this.ofsGroup.length > 0 && !this.state.updatedOnce) {
            await this.handleOfs();
            this.setState({updatedOnce: true});
        }
    }

    /**
     * @method _handleBuyNow - handles the add/cart functions of cta add to cart button.
     * @param {e} event
     */
    _handleBuyNow(e) {
        const productId = (this.state.productData.course_id) ? this.state.productData.course_id : 'suite_' + this.state.productId;
        const domain_id = this.state.api.domain_id;
        buyNow(productId, domain_id);
    }
    /**
     * @method _handleProductCtaStickyness - handles the product sticky cta on load.
     * @param {e} event
     */
    _handleProductCtaStickyness(e) {
        let status;
        status = this.productCtaBoxClass.SetStickyness();
        this.setState({ status });
    }
    /**
     * @method _handleProductCtaOnResize  - handles the product sticky cta on browser resize.
     * @param {e} event
     */
    _handleProductCtaOnResize(e) {
        let status;
        status = this.productCtaBoxClass.SetStickyness();
        this.setState({ status });
    }

    async _handleOfs() {
        if (this.state.productData) {
            const ofs = new A11yHelpers();
            ofs.createOffScreenContent('', this.ofsGroup);
        }
    }

    render() {
        const style = { position: 'relative' };
        return (
            <React.Fragment>
                <div id="productBox" className="product-box__cta__block mat-dropshadow inactive">
                    <div style={style}>
                        <Spinner isLoading={this.state.isLoading}></Spinner>
                        {(this.state.productData.icon) ?
                            <div className="product-box__img__container">
                                <div className="img-mask">
                                    <img className="cert-img fltr" src={this.state.productData.icon ? 'https://cdn3-d.mindedgeonline.com/skye/static/certificate_badge.png' : ''} alt="Suite Certificate Icon" />
                                    <img className="product-img fltr" src={this.state.productData.icon} alt={ReactHtmlParser(this.state.productData.title) + ' Course Icon'} />
                                </div>
                            </div>
                            : ''}

                        <div className="product-details">
                            {(this.state.productData.length) ?
                                <div className="product-box__estimated__length">
                                    <i className="product-box__estimated__length__icon fas fa-clock skye-blue " aria-hidden="true"></i>
                                    <span className="product-box__estimated__length__item"><span className="product-box__estimated_length">Estimated length:&nbsp;</span><span className="product-box__hours">{this.state.productData.length}</span></span>
                                </div>
                                : ''}

                            {(this.state.productData.access_length) ?
                                <div className="product-box__duration">
                                    <i className="far fa-calendar-alt skye-blue product-box__duration__icon" aria-hidden="true"></i>
                                    <span className="product-box__duration_item"><span className="product-box__access_time">Access Time:&nbsp;</span><span className="product-box__days">{this.state.productData.access_length}</span></span>
                                </div>
                                : ''}
                            {(this.state.productData.rating) ?
                                <div className="product-box__rating">
                                    <i className="product-box__rating__icon far fa-thumbs-up"></i>
                                    <span className="product-box__rating__number data-ofs" data-ofs={`Course rating is ${this.state.productData.rating}`}><span aria-hidden="true">{this.state.productData.rating}</span></span>
                                </div>
                                : ''}

                            {(this.state.productData.course_price) ?
                                <div className="price-container">
                                    <span className="listing-price text-bold data-ofs" data-ofs={this.state.productData.title + ' current price is $' + this.state.productData.course_price.list_price}><span aria-hidden="true">${this.state.productData.course_price.list_price}</span></span>
                                    {(this.state.productData.course_price.strikethrough_price) ?
                                        <span className="listing-stru-price strike-thru text-muted data-ofs"><span data-ofs={this.state.productData.title + ' regular price is $' + this.state.productData.course_price.strikethrough_price}><span aria-hidden="true">${this.state.productData.course_price.strikethrough_price}</span></span></span>
                                        : ''}
                                </div>
                                : ''}

                            {(this.state.productData.product_info) ?
                                <div className="price-container">
                                    <span className="listing-price text-bold data-ofs" data-ofs={this.state.productData.title + ' current price is $' + this.state.productData.product_info.list_price}><span aria-hidden="true">${this.state.productData.product_info.list_price}</span></span>
                                    {(this.state.productData.product_info.strikethrough_price) ?
                                        <span className="listing-stru-price strike-thru text-muted data-ofs" data-ofs={this.state.productData.title + ' regular price is $' + this.state.productData.product_info.strikethrough_price}><span aria-hidden="true">${this.state.productData.product_info.strikethrough_price}</span></span>
                                        : ''}
                                </div>
                                : ''}

                        </div>
                        <div className="cta-area">
                            {(this.state.productData.course_id) ?
                                <div id="addToCart" onClick={(e) => this._handleBuyNow(e)}>
                                    <React.Fragment>
                                        <button
                                            className={'btn add-btn btn-mid-green btn-mid-green--cr451 ttrans-n bradius-0 add-cart-' + this.state.productData.course_id}
                                            aria-label={'Add ' + ReactHtmlParser(this.state.productData.title) + ' to Cart'}
                                            data-toggle="snackbar"
                                            data-style="skye-snackbar"
                                            data-html-allowed="true"
                                            data-content="Product Added To Cart!"
                                        >Add to Cart</button>
                                    </React.Fragment>
                                </div>
                                :
                                <div id="addToCart" onClick={(e) => this._handleBuyNow(e)}>
                                    <React.Fragment>
                                        <button
                                            className={'btn add-btn btn-mid-green btn-mid-green--cr451 ttrans-n bradius-0 add-cart-suite_' + this.state.productData.suite_id}
                                            aria-label={'Add ' + ReactHtmlParser(this.state.productData.title) + ' to Cart'}
                                            data-toggle="snackbar"
                                            data-style="skye-snackbar"
                                            data-html-allowed="true"
                                            data-content="Product Added To Cart!"
                                        >Add to Cart</button>
                                    </React.Fragment>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ProductStickyCta;
